import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { PedidoService } from "src/app/core/services/pedido-service";
import { InitProvider } from "src/app/core/services/init-provider";

@Component({
  selector: "app-product-quantity-input",
  templateUrl: "./product-quantity-input.component.html",
  styleUrls: ["./product-quantity-input.component.css"],
})
export class ProductQuantityInputComponent implements OnInit {
  @Output()
  public onAdd = new EventEmitter<number>();
  @Input() product!: any;
    @Output()
  public redirectTo = new EventEmitter<number>();
  @Input()
  public produtoDescrHeight;
  public pedido: any;
  public quantity: number = 1;
  public inputClass: string = "";
  public SITE: any;
  public theme: any;
  public hovered: boolean = false;
  public error: boolean = false;
  public validaEstoque: boolean = true;
  public minQuantidade = 1
  public init = true

  constructor(
    public pedidoService: PedidoService,
    public initProvider: InitProvider,
    public toastService: ToastrService
  ) {
    this.pedido = this.pedidoService.pedido;
    if (this.product && this.product.quantidade_minima) {
      this.minQuantidade = this.product.quantidade_minima;
    }
    this.SITE = Configuracoes.SITE;
    this.theme = Configuracoes.themes.filter(
      (i) => i.id == Configuracoes.SITE.theme
    )[0];
  }

  ngOnInit(): void {
    if (this.pedidoService.pedido) {
      this.pedido = this.pedidoService.pedido;
      this.validaEstoque = this.pedidoService.pedido.tipo.validaEstoque;
    }
    if (this.product.quantidade && this.product.quantidade >= 1) {
      this.quantity = this.product.quantidade;
    }
    if (this.product.quantidade_minima) {
      this.minQuantidade = this.product.quantidade_minima;
    }
    if (this.product.multiplo) {
      this.quantity = this.product.multiplo !== null ? this.product.multiplo : 1;
      this.inputClass = "disabled";
    } else if (this.product.quantidade_minima) {
      this.quantity = this.product.quantidade_minima;
    } else {
      this.quantity = 1
    }

    this.quantity = this.product.quantidade === 0 || this.product.quantidade === null ? this.product.multiplo ? this.product.multiplo : 1 : this.product.quantidade;
  }
  
  // ngDoCheck() {
  //   if (this.init) {
  //     this.quantity = this.product.quantidade === 0 || this.product.quantidade === null ? this.product.multiplo ? this.product.multiplo : 1 : this.product.quantidade;
  //     console.log(this.quantity)
  //   } else {
  //     this.product.quantidade === null ? this.quantity = 1 : this.quantity = this.product.quantidade
  //     console.log(this.quantity)
  //   }
  // }

  public addCart() {
    if (this.product.multiplo && this.quantity % this.product.multiplo > 0) {
      this.error = true;
      this.toastService.warning(
        $localize`Quantidade múltipla de (` + this.product.multiplo + $localize`) incorreta!`,
        $localize`Produto`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    // if(this.product.quantidade_minima){
    if (0 < this.quantity && this.quantity < this.product.quantidade_minima) {
      this.error = true;
      this.toastService.warning(
        $localize`Quantidade inferior ao mínimo de ${this.product.quantidade_minima}`,
        $localize`Produto`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    // }

    if (
      this.product.estoque < this.quantity &&
      this.pedido.tipo.validaEstoque
    ) {
      this.error = true;
      this.toastService.warning($localize`Quantidade inválida. Verifique a quantidade minima e o estoque!`, $localize`Produto`, {
        positionClass: "toast-bottom-left",
      });
      return;
    }

    this.error = false;
    this.onAdd.emit(this.quantity);
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public setQuantity(event) {
    this.init = false
    this.quantity = Number(event.target.value);
    // this.product.quantidade = Number(event.target.value);
    this.inputClass = "";
  }

  public plus(multiplo: number) {
    this.init = false
    if (multiplo === null || multiplo === undefined) {
      multiplo = 1;
    }
    if (this.quantity === 0) {
      this.quantity = multiplo;
    } else if (this.quantity % multiplo === 0) {
      this.quantity = this.quantity + multiplo;
    } else {
      this.quantity = Math.ceil(this.quantity / multiplo) * multiplo;
    }
    this.inputClass = "";
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public less(multiplo: number) {
    this.init = false
    if (multiplo === null || multiplo === undefined) {
      multiplo = 1;
    }
    if (this.quantity === 0) {
      return;
    } else if (this.quantity === 1 || this.quantity < multiplo) {
      this.quantity = 0;
    }
    else if ((this.quantity - multiplo) < this.minQuantidade) {
      this.quantity = 0
    }
    else if (this.quantity % multiplo === 0) {
      this.quantity = this.quantity - multiplo;
    }
    else {
      this.quantity = Math.floor(this.quantity / multiplo) * multiplo;
    }
    this.inputClass = "";
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    if (this.pedidoService.pedido) {
      this.pedido = this.pedidoService.pedido;
      this.validaEstoque = this.pedidoService.pedido.tipo.validaEstoque;
    }
    if (this.product.quantidade && this.product.quantidade >= 1) {
      this.quantity = this.product.quantidade;
    }
    else if (this.product.quantidade_minima) {
      this.minQuantidade = this.product.quantidade_minima;
    }
    else if (this.product.multiplo) {
      this.quantity = this.product.multiplo !== null ? this.product.multiplo : 1;
      this.inputClass = "disabled";
    }
  }
}
